import { User } from "../../types";
import { admin, forecaster } from "./axios";
import { GetTrendsParams } from "./trends";

export type GetTrendCurvesParams = GetTrendsParams & {
  query_type?: string;
  curve_window?: string;
};

export const getTrendsCurveData = async (
  params: GetTrendCurvesParams,
  user: User | null
) => {
  if (user === null) {
    throw new Error("User is not available");
  }

  const { group } = user!;
  if (!group) {
    console.error("Group Not Found");
    return;
  }

  try {
    const apiClient =
      group === "admin" ? admin : group === "forecaster" ? forecaster : null;
    if (apiClient) {
      const response = await apiClient.get(`/trends/graph/curve`, {
        params,
      });
      return response?.data;
    } else {
      console.error("Group not found");
    }
  } catch (error) {
    console.error("Error fetching trends:", error);
    throw error;
  }
};
